import React from "react";
import Box from "./box";
import { SmallDivider } from "../shared";
import Title from "./title";
import Tagline from "./tagline";

export default function PageHeader({ title, tagline, children }) {
  return (
    <>
      <Box>
        <Title>{title}</Title>
      </Box>
      <Tagline>{tagline}</Tagline>
      {children}
      <Box>
        <SmallDivider />
      </Box>
    </>
  );
}
